// extracted by mini-css-extract-plugin
var _1 = "z0dD3";
var _2 = "e5_kE";
var _3 = "MRMMV";
export { _1 as "asideIcon", _2 as "asideLogo", _3 as "firstColumn" }
